/**
 * Aba "Minha conta".
 *
 * O único conteúdo desta tela é o atalho para a lista de compras, renderizado
 * pelo `ProfileLayout`. Fica como página própria para manter a navegação do
 * menu lateral coerente.
 */
export function ProfileOverviewPage() {
  return null
}
